<template>
    <el-dialog class="el-dialogs" :append-to-body="true" :title="title" :fullscreen="true" :close-on-click-modal="false"
               :visible.sync="visible">
        <div style="width: 50%">
            <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                     :disabled="title == '质检方案详情'"
                     label-width="110px">
                <el-form-item label="方案名称：" prop="schemeName">
                    <el-input v-model.trim="searchForm.schemeName" maxlength="20"
                              placeholder="请输入方案名称(限20字)"
                              clearable></el-input>
                </el-form-item>
                <el-form-item label="方案描述：" prop="schemeDescription">
                    <el-input
                            type="textarea"
                            placeholder="请输入方案描述(限200字)"
                            v-model.trim="searchForm.schemeDescription"
                            rows="4" resize="none"
                            maxlength="200"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="选择检测项：" prop="testingItems">
                    <el-tabs v-model="searchForm.testingItems" @tab-click="handleClick">
                        <el-tab-pane label="真实性" name="truth"></el-tab-pane>
                        <el-tab-pane label="完整性" name="integrity"></el-tab-pane>
                        <el-tab-pane label="可用性" name="usability"></el-tab-pane>
                        <el-tab-pane label="安全性" name="safety"></el-tab-pane>
                    </el-tabs>
                    <!--真实性-->
                    <div v-show="searchForm.testingItems == 'truth'">
                        <div class="minTitle">元数据检测</div>
                        <div class="paddLfefts">
                            <el-checkbox :indeterminate="truthMetadataIndeterminate" v-model="truthMetadataCheckAll"
                                         @change="(val)=>handleCheckAllChange(truthMetadataListType,'truthMetadataList','truthMetadataIndeterminate',val)">
                                全选
                            </el-checkbox>
                            <el-checkbox-group v-model="searchForm.truthMetadataList"
                                               @change="(val)=>handleCheckedCitiesChange(truthMetadataListType,'truthMetadataIndeterminate','truthMetadataCheckAll',val)"
                                               class="magTop">
                                <div v-for="item in truthMetadataListType" :key="item.id">
                                    <el-checkbox :label="item.id">
                                        <div class="flex_l_c">
                                            <div class="truthLabel">{{ item.qualityName }}</div>
                                            <div class="truthPrompt">{{ item.remark }}</div>
                                        </div>
                                    </el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </div>
                        <div class="minTitle">电子原文检测</div>
                        <div class="paddLfefts">
                            <el-checkbox :indeterminate="truthElectronIndeterminate" v-model="truthElectronCheckAll"
                                         @change="(val)=>handleCheckAllChange(truthElectronListType,'truthElectronList','truthElectronIndeterminate',val)">
                                全选
                            </el-checkbox>
                            <el-checkbox-group v-model="searchForm.truthElectronList"
                                               @change="(val)=>handleCheckedCitiesChange(truthElectronListType,'truthElectronIndeterminate','truthElectronCheckAll',val)"
                                               class="magTop">
                                <div v-for="item in truthElectronListType" :key="item.id">
                                    <el-checkbox :label="item.id">
                                        <div class="flex_l_c">
                                            <div class="truthLabel">{{ item.qualityName }}</div>
                                            <div class="truthPrompt">{{ item.remark }}</div>
                                        </div>
                                    </el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <!--真实性-->
                    <div v-show="searchForm.testingItems == 'integrity'">
                        <div class="minTitle">元数据检测</div>
                        <div class="paddLfefts">
                            <el-checkbox-group v-model="searchForm.integrityMetadataList">
                                <div v-for="item in integrityMetadataListType" :key="item.id">
                                    <el-checkbox :label="item.id">
                                        <div class="flex_l_c">
                                            <div class="truthLabel">{{ item.qualityName }}</div>
                                            <div class="truthPrompt">{{ item.remark }}</div>
                                        </div>
                                    </el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </div>
                        <div class="minTitle">电子原文检测</div>
                        <div class="paddLfefts">
                            <el-checkbox-group v-model="searchForm.integrityElectronList">
                                <div v-for="item in integrityElectronListType" :key="item.id">
                                    <el-checkbox :label="item.id">
                                        <div class="flex_l_c">
                                            <div class="truthLabel">{{ item.qualityName }}</div>
                                            <div class="truthPrompt">{{ item.remark }}</div>
                                        </div>
                                    </el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <!--可用性-->
                    <div v-show="searchForm.testingItems == 'usability'">
                        <div class="minTitle">元数据检测</div>
                        <div class="paddLfefts">
                            <el-checkbox-group v-model="searchForm.usabilityMetadataList">
                                <div v-for="item in usabilityMetadataListType" :key="item.id">
                                    <el-checkbox :label="item.id">
                                        <div class="flex_l_c">
                                            <div class="truthLabel">{{ item.qualityName }}</div>
                                            <div class="truthPrompt">{{ item.remark }}</div>
                                        </div>
                                    </el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </div>
                        <div class="minTitle">电子原文检测</div>
                        <div class="paddLfefts">
                            <el-checkbox-group v-model="searchForm.usabilityElectronList">
                                <div v-for="item in usabilityElectronListType" :key="item.id">
                                    <el-checkbox :label="item.id">
                                        <div class="flex_l_c">
                                            <div class="truthLabel">{{ item.qualityName }}</div>
                                            <div class="truthPrompt">{{ item.remark }}</div>
                                        </div>
                                    </el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <!--安全性-->
                    <div v-show="searchForm.testingItems == 'safety'">
                        <div class="minTitle">电子原文检测</div>
                        <div class="paddLfefts">
                            <el-checkbox-group v-model="searchForm.safetyElectronList">
                                <div v-for="item in safetyElectronListListType" :key="item.id">
                                    <el-checkbox :label="item.id">
                                        <div class="flex_l_c">
                                            <div class="truthLabel">{{ item.qualityName }}</div>
                                            <div class="truthPrompt">{{ item.remark }}</div>
                                        </div>
                                    </el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="执行周期：" prop="period">
                    <el-select style="width: 100%" v-model="searchForm.period" @change="changeCycleMed"
                               placeholder="请选择执行周期">
                        <el-option
                                v-for="item in periodList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <div class="magTop" v-if="searchForm.period == 0">
                        <el-radio-group v-model="searchForm.periodType" @change="changeCycle">
                            <el-radio label="0">每年</el-radio>
                            <el-radio label="1">每月</el-radio>
                            <el-radio label="2">每周</el-radio>
                            <el-radio label="3">每日</el-radio>
                        </el-radio-group>
                        <div class="flex_b_c variation">
                            <el-form-item label="年执行月份：" prop="schemeMonth">
                                <el-input v-model.trim="searchForm.schemeMonth" maxlength="2"
                                          :disabled="searchForm.periodType > 0"
                                          placeholder="请输入执行月份(1~12)"
                                          clearable></el-input>
                            </el-form-item>
                            <el-form-item label="月执行日：" prop="schemeDay">
                                <el-input v-model.trim="searchForm.schemeDay" maxlength="2"
                                          :disabled="searchForm.periodType > 1"
                                          placeholder="请输入月执行日(1~31)"
                                          clearable></el-input>
                            </el-form-item>
                            <el-form-item label="周执行日：" prop="schemeWeek">
                                <el-input v-model.trim="searchForm.schemeWeek" maxlength="1"
                                          :disabled="searchForm.periodType != 2"
                                          placeholder="请输入周执行日(1~7)"
                                          clearable></el-input>
                            </el-form-item>
                            <el-form-item label="日执行时间：" prop="schemeDays">
                                <el-input v-model.trim="searchForm.schemeDays" maxlength="5"
                                          placeholder="请输入日执行时间(HH:mm)"
                                          clearable></el-input>
                            </el-form-item>
                            <el-tooltip class="item" effect="dark" content="时间格式:hh:mm,有多个时间时，以英文逗号分隔"
                                        placement="top">
                                <div class="iconPrompt el-icon-question"></div>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="magTop" v-else>
                        <el-form-item label="执行周期：" prop="schemeCron" class="itemInput">
                            <div class="flex_b_c">
                                <el-input v-model="searchForm.schemeCron" maxlength="50"
                                          placeholder="请输入执行周期(限50字)" style="margin-right: 10px"
                                          clearable></el-input>
                                <el-popover
                                        placement="top-start"
                                        width="600"
                                        trigger="hover">
                                    <div style="white-space: pre-wrap;">
                                        cron表达式‌通常指的是包含6个字段的CRON表达式。
                                        每个字段的具体含义如下：<br>
                                        秒（0~59）<br>
                                        分钟（0~59）<br>
                                        小时（0~23）<br>
                                        天（月）（1~31，取决于月份）<br>
                                        月（1~12）<br>
                                        ‌星期‌（0-6，0表示周日）：表示一周中的第几天。<br>
                                        cron表达式举例：<br>
                                        0 0 10 * * ? 每天10点触发一次<br>
                                        0 30 9 1 * ? 每月1号上午9点半<br>
                                        0 15 10 15 * ? 每月15日上午10:15触发<br>
                                        Cron表达式的特殊字符及其含义<br>
                                        ‌星号（*）‌：表示任何值，例如在“分钟”字段中使用*表示每分钟都执行任务。<br>
                                        ‌问号（?）‌：表示无特定值，通常用于“月中的日”和“周中的日”字段之间的互斥。<br>
                                        ‌连字符（-）‌：表示一个范围，例如10-12在“小时”字段中表示从10到12点每小时。<br>
                                        ‌逗号（,）‌：用于列出多个值，例如在“周中的日”字段中表示每周的星期一、三、五。<br>
                                        ‌斜杠（/）‌：表示增量，例如0/15表示从0分钟开始，每15分钟执行一次‌<br>
                                    </div>
                                    <div slot="reference" class="iconPrompt el-icon-question"></div>
                                </el-popover>
                            </div>
                        </el-form-item>
                    </div>
                </el-form-item>
                <el-form-item label="状态：" prop="schemeState">
                    <el-switch
                            v-model="searchForm.schemeState"
                            active-value="1"
                            inactive-value="0">
                    </el-switch>
                </el-form-item>
            </el-form>
        </div>
        <div v-if="title != '质检方案详情'" slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="danger" @click="saveData()" v-no-more-click>保存</el-button>
        </div>
        <div v-else slot="footer">
            <el-button size="small" @click="visible = false">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import cronParser from "cron-parser";
import {isValidCron} from "cron-validator";
export default {
    name: "addQuality",
    data() {
        var verifyMonth = (rule, value, callback) => {
            if (this.searchForm.periodType == 0) {
                if (value === '') {
                    callback(new Error('请输入执行月份(1~12)'));
                } else {
                    let data = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
                    if (!data.includes(value)) {
                        callback(new Error('请输入正确的执行月份(1~12)'));
                    }
                    callback();
                }
            }else {
                callback();
            }
        };
        var verifyExecutionDate = (rule, value, callback) => {
            if (this.searchForm.periodType == 1 || this.searchForm.periodType == 0) {
                if (value === '') {
                    callback(new Error('请输入月执行日(1~31)'));
                } else {
                    let data = []
                    for (let i = 1; i <= 31; i++) {
                        data.push(i.toString())
                    }
                    if (!data.includes(value)) {
                        callback(new Error('请输入正确的月执行日(1~31)'));
                    } else {
                        callback();
                    }
                }
            }else {
                callback();
            }
        };
        var verifyweeklyExecution = (rule, value, callback) => {
            if (this.searchForm.periodType == '2') {
                if (value === '') {
                    callback(new Error('请输入周执行日(1~7)'));
                } else {
                    let data = []
                    for (let i = 1; i <= 7; i++) {
                        data.push(i.toString())
                    }
                    if (!data.includes(value)) {
                        callback(new Error('请输入正确的周执行日(1~7)'));
                    } else {
                        callback();
                    }
                }
            }else {
                callback();
            }
        };
        var verifyExecutionTime = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入日执行时间(HH:mm)'));
            } else {
                const timeRegex = /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/;
                if (!timeRegex.test(value)) {
                    callback(new Error('请输入正确的日执行时间(HH:mm)'));
                } else {
                    callback();
                }
            }
        };
        var validateCron = (rule, value, callback) => {
            this.searchForm.schemeCron = this.searchForm.schemeCron.trim()
            value = this.searchForm.schemeCron
            if (value === '') {
                callback(new Error('请输入cron表达式'));
            }else {
                try {
                    cronParser.parseExpression(value);
                    callback();
                } catch (error) {
                    callback(new Error('请输入正确的cron表达式'));
                }
            }
        };
        return {
            title: '新增质检方案',
            visible: false,
            searchForm: {
                id: '',
                schemeName: '',
                schemeDescription: '',
                testingItems: 'truth',
                truthMetadataList: [],
                truthElectronList: [],
                integrityMetadataList: [],
                integrityElectronList: [],
                usabilityMetadataList: [],
                usabilityElectronList: [],
                safetyElectronList: [],
                itemIds: [],
                period: '0',
                periodType: '0',
                schemeMonth: '',
                schemeDay: '',
                schemeWeek: '',
                schemeDays: '',
                schemeCron: '',
                schemeState: '0',
            },
            rules: {
                schemeName: [
                    {required: true, message: '请输入方案名称', trigger: 'blur'}
                ],
                testingItems: [
                    {required: true, message: '请选择检测项', trigger: 'change'}
                ],
                period: [
                    {required: true, message: '请选择执行周期', trigger: 'change'}
                ],
                schemeMonth: [
                    {validator: verifyMonth, trigger: 'blur'},
                ],
                schemeDay: [
                    {validator: verifyExecutionDate, trigger: 'blur'},
                ],
                schemeWeek: [
                    {validator: verifyweeklyExecution, trigger: 'blur'},
                ],
                schemeDays: [
                    {validator: verifyExecutionTime, trigger: 'blur'},
                ],
                schemeCron: [
                    {validator: validateCron, trigger: 'blur'},
                ],
                schemeState: [
                    {required: true, message: '请选择状态', trigger: 'change'}
                ],
            },
            periodList: [
                {
                    value: '0',
                    label: '周期执行',
                },
                {
                    value: '1',
                    label: '自定义',
                },
            ],

            //真实性-元数据检测
            truthMetadataCheckAll: false,
            truthMetadataIndeterminate: false,
            truthMetadataListType: [],

            //真实性-电子原文检测
            truthElectronCheckAll: false,
            truthElectronIndeterminate: false,
            truthElectronListType: [],

            //完整性-元数据检测
            integrityMetadataListType: [],

            //完整性-电子原文检测
            integrityElectronListType: [],

            //可用性-元数据检测
            usabilityMetadataListType: [],

            //可用性-电子原文检测
            usabilityElectronListType: [],

            //安全性-电子原文检测
            safetyElectronListListType: [],

        }
    },
    methods: {
        init(typeName, row) {
            this.searchForm.id = ''
            this.searchForm.periodType = '0'
            this.visible = true
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields()
                this.changeCycle()
            })
            this.getOtherData(typeName, row)
        },

        getOtherData(typeName, row) {
            this.$axios(this.api.academic.qualityinspectionitemListAll).then(data => {
                if (data && data.code == 200) {
                    this.truthMetadataListType = data.qualityInspectionItems00
                    this.truthElectronListType = data.qualityInspectionItems01
                    this.integrityMetadataListType = data.qualityInspectionItems10
                    this.integrityElectronListType = data.qualityInspectionItems11
                    this.usabilityMetadataListType = data.qualityInspectionItems20
                    this.usabilityElectronListType = data.qualityInspectionItems21
                    this.safetyElectronListListType = data.qualityInspectionItems30

                    if (typeName == 'add') {
                        this.title = '新增质检方案'
                        this.searchForm.truthMetadataList = []
                        this.searchForm.truthElectronList = []
                        this.searchForm.integrityMetadataList = []
                        this.searchForm.integrityElectronList = []
                        this.searchForm.usabilityMetadataList = []
                        this.searchForm.usabilityElectronList = []
                        this.searchForm.safetyElectronList = []
                        this.truthElectronIndeterminate = true
                        this.truthMetadataIndeterminate = true
                        this.handleCheckedCitiesChange(this.truthMetadataListType, 'truthMetadataIndeterminate', 'truthMetadataCheckAll', this.searchForm.truthMetadataList)
                        this.handleCheckedCitiesChange(this.truthElectronListType, 'truthElectronIndeterminate', 'truthElectronCheckAll', this.searchForm.truthElectronList)
                    }
                    if (typeName == 'edit') {
                        this.title = '编辑质检方案'
                        this.getDetail(row.id)
                    }
                    if (typeName == 'detail') {
                        this.title = '质检方案详情'
                        this.getDetail(row.id)
                    }
                }
            })
        },

        getDetail(id) {
            this.$axios(this.api.academic.qualityinspectionGetById + id).then(data => {
                if (data && data.status) {
                    Object.keys(this.searchForm).forEach(key => {
                        this.searchForm[key] = data.data[key]
                    })
                    this.searchForm.truthMetadataList = []
                    this.searchForm.truthElectronList = []
                    this.searchForm.integrityMetadataList = []
                    this.searchForm.integrityElectronList = []
                    this.searchForm.usabilityMetadataList = []
                    this.searchForm.usabilityElectronList = []
                    this.searchForm.safetyElectronList = []
                    this.searchForm.itemIds.forEach(item => {
                        if (item <= 6) {
                            this.searchForm.truthMetadataList.push(item)
                        } else if (item <= 8) {
                            this.searchForm.truthElectronList.push(item)
                        } else if (item <= 11) {
                            this.searchForm.integrityMetadataList.push(item)
                        } else if (item <= 12) {
                            this.searchForm.integrityElectronList.push(item)
                        } else if (item <= 13) {
                            this.searchForm.usabilityMetadataList.push(item)
                        } else if (item <= 14) {
                            this.searchForm.usabilityElectronList.push(item)
                        } else if (item <= 16) {
                            this.searchForm.safetyElectronList.push(item)
                        }
                    })
                    this.searchForm.testingItems = 'truth'
                    this.handleCheckedCitiesChange(this.truthMetadataListType, 'truthMetadataIndeterminate', 'truthMetadataCheckAll', this.searchForm.truthMetadataList)
                    this.handleCheckedCitiesChange(this.truthElectronListType, 'truthElectronIndeterminate', 'truthElectronCheckAll', this.searchForm.truthElectronList)
                }
            })
        },

        handleClick(tab) {
            // console.log(tab)
        },

        //是否全选
        /*
           * list 需要全选的数据
           * selectListName 多选数据储存的名字
           * indeterminateName 全选状态控制的名字
           * val 全选是否选中
         */
        handleCheckAllChange(list, selectListName, indeterminateName, val) {
            let allIds = list.map(item => {
                return item.id
            })
            this.searchForm[selectListName] = val ? allIds : [];
            this[indeterminateName] = false;
        },

        //单选
        /*
           * list 需要全选的数据
           * indeterminateName 全选状态控制的名字
           * checkAllName 全选是否选中的名字
           * value 选中的所有数据
         */
        handleCheckedCitiesChange(list, indeterminateName, checkAllName, value) {
            let checkedCount = value.length;
            this[checkAllName] = checkedCount === list.length;
            if (checkedCount == 0) {
                this[indeterminateName] = false
            } else {
                this[indeterminateName] = checkedCount < list.length;
            }
        },

        //执行周期切换
        changeCycleMed() {
            if (this.searchForm.period == 1) {
                this.searchForm.schemeMonth = ''
                this.searchForm.schemeDay = ''
                this.searchForm.schemeWeek = ''
                this.searchForm.schemeDays = ''
            } else {
                this.schemeCron = ''
            }
        },

        //执行固定周期执行
        changeCycle() {
            if (this.searchForm.periodType == '0') {
                this.searchForm.schemeWeek = ''
                this.$refs.searchForm.clearValidate('schemeWeek');
            }
            if (this.searchForm.periodType == '1') {
                this.searchForm.schemeMonth = ''
                this.searchForm.schemeWeek = ''
                this.$refs.searchForm.clearValidate([
                    'schemeMonth',
                    'schemeWeek'
                ]);
            }
            if (this.searchForm.periodType == '2') {
                this.searchForm.schemeMonth = ''
                this.searchForm.schemeDay = ''
                this.$refs.searchForm.clearValidate([
                    'schemeMonth',
                    'schemeDay'
                ]);
            }
            if (this.searchForm.periodType == '3') {
                this.searchForm.schemeMonth = ''
                this.searchForm.schemeDay = ''
                this.searchForm.schemeWeek = ''
                this.$refs.searchForm.clearValidate([
                    'schemeMonth',
                    'schemeDay',
                    'schemeWeek'
                ]);
            }
        },

        //保存
        saveData() {
            this.searchForm.itemIds = [
                ...this.searchForm.truthMetadataList,
                ...this.searchForm.truthElectronList,
                ...this.searchForm.integrityMetadataList,
                ...this.searchForm.integrityElectronList,
                ...this.searchForm.usabilityMetadataList,
                ...this.searchForm.usabilityElectronList,
                ...this.searchForm.safetyElectronList,
            ]
            let schemeType = []
            if (this.searchForm.truthMetadataList.length || this.searchForm.truthElectronList.length) {
                schemeType.push('0')
            }
            if (this.searchForm.integrityMetadataList.length || this.searchForm.integrityElectronList.length) {
                schemeType.push('1')
            }
            if (this.searchForm.usabilityMetadataList.length || this.searchForm.usabilityElectronList.length) {
                schemeType.push('2')
            }
            if (this.searchForm.safetyElectronList.length) {
                schemeType.push('3')
            }
            schemeType = schemeType.join(',')
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.searchForm.id) {
                        this.$axios(this.api.academic.qualityinspectionUpdateById, {
                            ...this.searchForm,
                            schemeType,
                        }, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success(`修改成功`)
                                this.$emit('refresh')
                                this.visible = false
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.academic.qualityinspectionSave, {
                            ...this.searchForm,
                            schemeType,
                        }, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success(`保存成功`)
                                this.$emit('refresh')
                                this.visible = false
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
.minTitle {
    font-size: 14px;
    font-weight: bold;
}

.magTop {
    margin-top: 10px;
}

.truthLabel {
    width: 160px;
}

.truthPrompt {
    color: #8c939d;
}

.paddLfefts {
    padding-left: 30px
}

.variation {
    flex-wrap: wrap;
    position: relative;

    .el-form-item {
        width: 49%;
    }

    .iconPrompt {
        position: absolute;
        right: -40px;
        bottom: 24px;
        font-size: 22px;
        width: 22px;
        height: 22px;
    }
}
</style>
